<template>
  <div v-if="repairImageModal">
    <h5>Repair photo</h5>
    <img :src="repairImageModal || 'img/image_not_found.png'" alt="damage" class="img-damage img-thumbnail">
  </div>
</template>

<script>
import { mapState } from 'vuex'
export default {
  computed: {
    ...mapState({
      
      repairImageModal: (state) =>
        state.vehicle.visualInspection.repairImageModal,
    })
  },
}
</script>

<style scoped>
.img-damage {
  max-height: 100%;
  width: auto;
  display: inline-block;
  float: none;
}
</style>